<script setup lang="ts">
import { ref } from 'vue';
import CityMapContainer from '@/components/CityMapContainer.vue';
import LoadingScreen from '@/components/LoadingScreen.vue';

const isLoaderDisplayed = ref(true);
const isLoaderVisible = ref(true);
</script>

<template>
  <main>
    <div class="relative h-dvh w-dvw overflow-hidden">
      <div class="absolute left-0 top-0 size-full" :class="isLoaderVisible && 'invisible'">
        <CityMapContainer />
      </div>
      <div v-if="isLoaderDisplayed" class="absolute left-0 top-0 size-full">
        <LoadingScreen @t-end="isLoaderDisplayed = false" @close="isLoaderVisible = false" />
      </div>
    </div>
  </main>
</template>
